import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: ['Inter', 'serif'].join(', '),
    allVariants: {
      lineHeight: 'inherit',
    },
    h1: {
      fontSize: '1.25rem',
    },
  },
  palette: {
    error: {
      main: '#DE2700',
    },
  },
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: {
          color: '#FF3C12',
        },
      },
    },
  },
});

export default theme;
